import React, { useState, useEffect } from 'react';

const TenantForm = ({ tenant, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    onshapeCompanyId: '',
    companyName: '',
    onshapeApiUrl: 'https://cad.onshape.com/api',
    notes: ''
  });

  useEffect(() => {
    if (tenant) {
      setFormData({
        onshapeCompanyId: tenant.onshape_company_id || '',
        companyName: tenant.company_name || '',
        onshapeApiUrl: tenant.onshape_api_url || 'https://cad.onshape.com/api',
        notes: tenant.notes || ''
      });
    }
  }, [tenant]);

  function handleInputChange(e) {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }

  function handleSubmit(e) {
    e.preventDefault();

    // For updates, only send changed fields
    if (tenant) {
      const updates = {};
      if (formData.companyName !== tenant.company_name) {
        updates.companyName = formData.companyName;
      }
      if (formData.onshapeApiUrl !== tenant.onshape_api_url) {
        updates.onshapeApiUrl = formData.onshapeApiUrl;
      }
      if (formData.notes !== (tenant.notes || '')) {
        updates.notes = formData.notes;
      }
      onSubmit(updates);
    } else {
      // For creates, send all data
      onSubmit(formData);
    }
  }

  return (
    <div className="form-container">
      <div className="form-header">
        <h3>{tenant ? 'Edit Tenant' : 'Create New Tenant'}</h3>
      </div>

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="form-group">
          <label htmlFor="onshapeCompanyId">
            Onshape Company ID <span className="required">*</span>
          </label>
          <input
            type="text"
            id="onshapeCompanyId"
            name="onshapeCompanyId"
            value={formData.onshapeCompanyId}
            onChange={handleInputChange}
            required
            disabled={!!tenant} // Cannot change company ID on update
            placeholder="e.g., 5f3c4a8b9e7d6c5a4b3d2e1f"
          />
          <small className="help-text">
            The unique Onshape company ID from the URL or API
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="companyName">
            Company Name <span className="required">*</span>
          </label>
          <input
            type="text"
            id="companyName"
            name="companyName"
            value={formData.companyName}
            onChange={handleInputChange}
            required
            placeholder="e.g., Acme Corporation"
          />
        </div>

        <div className="form-group">
          <label htmlFor="onshapeApiUrl">
            Onshape API URL <span className="required">*</span>
          </label>
          <input
            type="url"
            id="onshapeApiUrl"
            name="onshapeApiUrl"
            value={formData.onshapeApiUrl}
            onChange={handleInputChange}
            required
            placeholder="https://cad.onshape.com/api"
          />
          <small className="help-text">
            Usually https://cad.onshape.com/api (or enterprise URL)
          </small>
        </div>

        <div className="form-group">
          <label htmlFor="notes">Notes</label>
          <textarea
            id="notes"
            name="notes"
            value={formData.notes}
            onChange={handleInputChange}
            rows="4"
            placeholder="Optional notes about this tenant..."
          />
        </div>

        <div className="form-actions">
          <button type="button" onClick={onCancel} className="btn btn-secondary">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            {tenant ? 'Update Tenant' : 'Create Tenant'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TenantForm;
